import React, { memo, Component } from 'react';
import { Phone, Printer, Share2 } from 'lucide-react';
export function VehicleInspectionAidPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5789">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-12" data-id="element-5790">
        <div className="container mx-auto px-4" data-id="element-5791">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center italic" data-id="element-5792">
            Vehicle Inspection Memory Aid
          </h1>
        </div>
      </div>

      {/* Print/Share Actions */}
      <div className="bg-white border-b-2 border-gray-200" data-id="element-5793">
        <div className="container mx-auto px-4 py-4" data-id="element-5794">
          <div className="max-w-6xl mx-auto flex justify-center gap-4" data-id="element-5795">
            <button onClick={() => window.print()} className="flex items-center bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors" data-id="element-5796">
              <Printer className="mr-2" size={18} data-id="element-5797" />
              Print this page
            </button>
            <button onClick={() => {
            if (navigator.share) {
              navigator.share({
                title: 'Vehicle Inspection Memory Aid',
                text: 'Check out this vehicle inspection memory aid',
                url: window.location.href
              });
            }
          }} className="flex items-center bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors" data-id="element-5798">
              <Share2 className="mr-2" size={18} data-id="element-5799" />
              Send Page to Friend
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-8" data-id="element-5800">
        <div className="max-w-6xl mx-auto" data-id="element-5801">
          {/* Top Row - 4 Columns */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-4" data-id="element-5802">
            {/* Engine Compartment */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5803">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5804">
                <h2 className="font-bold text-center text-sm" data-id="element-5805">
                  Engine Compartment
                </h2>
              </div>
              <div className="p-4" data-id="element-5806">
                <ul className="space-y-1 text-sm" data-id="element-5807">
                  <li data-id="element-5808">leaks/hoses/all belts</li>
                  <li data-id="element-5809">oil level</li>
                  <li data-id="element-5810">coolant level</li>
                  <li data-id="element-5811">power steering fluid</li>
                  <li data-id="element-5812">water pump/fan</li>
                  <li data-id="element-5813">alternator</li>
                  <li data-id="element-5814">air compressor</li>
                </ul>
              </div>
            </div>

            {/* Cab Check/Engine Start */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5815">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5816">
                <h2 className="font-bold text-center text-sm" data-id="element-5817">
                  Cab Check/Engine Start
                </h2>
              </div>
              <div className="p-4" data-id="element-5818">
                <ul className="space-y-1 text-sm" data-id="element-5819">
                  <li data-id="element-5820">clutch/gearshift</li>
                  <li data-id="element-5821">oil pressure gauge</li>
                  <li data-id="element-5822">temperature gauge/voltmeter</li>
                  <li data-id="element-5823">mirrors, windshield</li>
                  <li data-id="element-5824">emer equip (f-e-t) (fa-fl)</li>
                  <li data-id="element-5825">steering play</li>
                  <li data-id="element-5826">wipers/washers</li>
                  <li data-id="element-5827">lighting indicators horn</li>
                  <li data-id="element-5828">heater/defroster</li>
                  <li data-id="element-5829">park/hydraulic brake ck</li>
                  <li data-id="element-5830">air brake ck (loss/warn/tpv-pv)</li>
                  <li data-id="element-5831">safety belt</li>
                </ul>
              </div>
            </div>

            {/* Lights/Reflectors */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5832">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5833">
                <h2 className="font-bold text-center text-sm" data-id="element-5834">
                  Lights/Reflectors
                </h2>
              </div>
              <div className="p-4" data-id="element-5835">
                <ul className="space-y-1 text-sm" data-id="element-5836">
                  <li data-id="element-5837">clearance/strobe</li>
                  <li data-id="element-5838">head</li>
                  <li data-id="element-5839">tail</li>
                  <li data-id="element-5840">turns</li>
                  <li data-id="element-5841">4-ways (amb-red-arm)</li>
                  <li data-id="element-5842">brakes</li>
                  <li data-id="element-5843">reflectors</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Bottom Row - 4 Columns */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-5844">
            {/* TRAILER */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5845">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5846">
                <h2 className="font-bold text-center text-sm" data-id="element-5847">TRAILER</h2>
              </div>
              <div className="p-4" data-id="element-5848">
                <div className="space-y-3 text-sm" data-id="element-5849">
                  <div data-id="element-5850">
                    <p className="font-bold mb-1" data-id="element-5851">Trailer Front</p>
                    <ul className="space-y-1" data-id="element-5852">
                      <li data-id="element-5853">air/electric connections</li>
                      <li data-id="element-5854">header board</li>
                    </ul>
                  </div>

                  <div data-id="element-5855">
                    <p className="font-bold mb-1" data-id="element-5856">Side of Trailer</p>
                    <ul className="space-y-1" data-id="element-5857">
                      <li data-id="element-5858">landing gear</li>
                      <li data-id="element-5859">doors, ties, lift</li>
                      <li data-id="element-5860">frame</li>
                      <li data-id="element-5861">tandem release arm</li>
                      <li data-id="element-5862">(locking pins)</li>
                    </ul>
                  </div>

                  <div data-id="element-5863">
                    <p className="font-bold mb-1" data-id="element-5864">Wheels</p>
                    <ul className="space-y-1" data-id="element-5865">
                      <li data-id="element-5866">rims</li>
                      <li data-id="element-5867">tires</li>
                      <li data-id="element-5868">axle seals</li>
                      <li data-id="element-5869">lug nuts</li>
                      <li data-id="element-5870">spacers</li>
                    </ul>
                  </div>

                  <div data-id="element-5871">
                    <p className="font-bold mb-1" data-id="element-5872">Suspension</p>
                    <ul className="space-y-1" data-id="element-5873">
                      <li data-id="element-5874">springs/air/torque</li>
                      <li data-id="element-5875">mounts</li>
                      <li data-id="element-5876">shocks</li>
                    </ul>
                  </div>

                  <div data-id="element-5877">
                    <p className="font-bold mb-1" data-id="element-5878">Brakes</p>
                    <ul className="space-y-1" data-id="element-5879">
                      <li data-id="element-5880">slack adjustors</li>
                      <li data-id="element-5881">chambers</li>
                      <li data-id="element-5882">hoses/lines</li>
                      <li data-id="element-5883">discs/drums/linings</li>
                    </ul>
                  </div>

                  <div data-id="element-5884">
                    <p className="font-bold mb-1" data-id="element-5885">Rear of Trailer</p>
                    <ul className="space-y-1" data-id="element-5886">
                      <li data-id="element-5887">doors, ties, lift</li>
                      <li data-id="element-5888">splash guards</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* SCHOOL BUS/TRUCK/TRACTOR */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5889">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5890">
                <h2 className="font-bold text-center text-sm" data-id="element-5891">
                  SCHOOL BUS/TRUCK/TRACTOR
                </h2>
              </div>
              <div className="p-4" data-id="element-5892">
                <div className="space-y-3 text-sm" data-id="element-5893">
                  <div data-id="element-5894">
                    <p className="font-bold mb-1" data-id="element-5895">Steering</p>
                    <ul className="space-y-1" data-id="element-5896">
                      <li data-id="element-5897">steering box/hoses</li>
                      <li data-id="element-5898">steering linkage</li>
                    </ul>
                  </div>

                  <div data-id="element-5899">
                    <p className="font-bold mb-1" data-id="element-5900">Front Suspension</p>
                    <ul className="space-y-1" data-id="element-5901">
                      <li data-id="element-5902">springs/air</li>
                      <li data-id="element-5903">mounts</li>
                      <li data-id="element-5904">shock</li>
                    </ul>
                  </div>

                  <div data-id="element-5905">
                    <p className="font-bold mb-1" data-id="element-5906">Front Brake</p>
                    <ul className="space-y-1" data-id="element-5907">
                      <li data-id="element-5908">slack adjustor</li>
                      <li data-id="element-5909">chamber</li>
                      <li data-id="element-5910">hose/line</li>
                      <li data-id="element-5911">disc/drums/linings</li>
                    </ul>
                  </div>

                  <div data-id="element-5912">
                    <p className="font-bold mb-1" data-id="element-5913">Front Wheel</p>
                    <ul className="space-y-1" data-id="element-5914">
                      <li data-id="element-5915">rim</li>
                      <li data-id="element-5916">tire</li>
                      <li data-id="element-5917">hub oil seal</li>
                      <li data-id="element-5918">lug nuts</li>
                    </ul>
                  </div>

                  <div data-id="element-5919">
                    <p className="font-bold mb-1" data-id="element-5920">Side of Vehicle</p>
                    <ul className="space-y-1" data-id="element-5921">
                      <li data-id="element-5922">Door, mirror, stop arm</li>
                    </ul>
                  </div>

                  <div data-id="element-5923">
                    <p className="font-bold mb-1" data-id="element-5924">Area</p>
                    <ul className="space-y-1" data-id="element-5925">
                      <li data-id="element-5926">Fuel tank</li>
                      <li data-id="element-5927">Battery/box</li>
                      <li data-id="element-5928">Drive shaft</li>
                      <li data-id="element-5929">Exhaust system</li>
                      <li data-id="element-5930">Frame</li>
                    </ul>
                  </div>

                  <div data-id="element-5931">
                    <p className="font-bold mb-1" data-id="element-5932">School/Other Bus</p>
                    <ul className="space-y-1" data-id="element-5933">
                      <li data-id="element-5934">Passenger entry/lifts</li>
                      <li data-id="element-5935">Emergency exits</li>
                      <li data-id="element-5936">Seating</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Column 3 - Rear Components */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5937">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5938">
                <h2 className="font-bold text-center text-sm" data-id="element-5939">
                  REAR COMPONENTS
                </h2>
              </div>
              <div className="p-4" data-id="element-5940">
                <div className="space-y-3 text-sm" data-id="element-5941">
                  <div data-id="element-5942">
                    <p className="font-bold mb-1" data-id="element-5943">Rear Suspension</p>
                    <ul className="space-y-1" data-id="element-5944">
                      <li data-id="element-5945">spring/air/torque</li>
                      <li data-id="element-5946">shocks</li>
                      <li data-id="element-5947">mounts</li>
                    </ul>
                  </div>

                  <div data-id="element-5948">
                    <p className="font-bold mb-1" data-id="element-5949">Rear brakes</p>
                    <ul className="space-y-1" data-id="element-5950">
                      <li data-id="element-5951">slack adjustors</li>
                      <li data-id="element-5952">chambers</li>
                      <li data-id="element-5953">hoses/lines</li>
                      <li data-id="element-5954">discs/drums/linings</li>
                    </ul>
                  </div>

                  <div data-id="element-5955">
                    <p className="font-bold mb-1" data-id="element-5956">Rear wheels</p>
                    <ul className="space-y-1" data-id="element-5957">
                      <li data-id="element-5958">rims</li>
                      <li data-id="element-5959">tires</li>
                      <li data-id="element-5960">lug nuts</li>
                      <li data-id="element-5961">spacers</li>
                    </ul>
                  </div>

                  <div data-id="element-5962">
                    <p className="font-bold mb-1" data-id="element-5963">Rear of vehicle</p>
                    <ul className="space-y-1" data-id="element-5964">
                      <li data-id="element-5965">splash guards</li>
                      <li data-id="element-5966">doors, ties, lift</li>
                    </ul>
                  </div>

                  <div data-id="element-5967">
                    <p className="font-bold mb-1" data-id="element-5968">Tractor/Coupling</p>
                    <ul className="space-y-1" data-id="element-5969">
                      <li data-id="element-5970">air/electric lines</li>
                      <li data-id="element-5971">catwalk</li>
                    </ul>
                  </div>

                  <div data-id="element-5972">
                    <p className="font-bold mb-1" data-id="element-5973">Coupling</p>
                    <ul className="space-y-1" data-id="element-5974">
                      <li data-id="element-5975">mounting bolts</li>
                      <li data-id="element-5976">Locking jaws</li>
                      <li data-id="element-5977">kingpin/apron/gap</li>
                      <li data-id="element-5978">platform</li>
                      <li data-id="element-5979">Emergency exits release arm</li>
                      <li data-id="element-5980">sliding 5th wheel</li>
                      <li data-id="element-5981">(locking pins)</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* COACH/TRANSIT BUS */}
            <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-5982">
              <div className="bg-gray-300 px-4 py-3" data-id="element-5983">
                <h2 className="font-bold text-center text-sm" data-id="element-5984">
                  COACH/TRANSIT BUS
                </h2>
              </div>
              <div className="p-4" data-id="element-5985">
                <div className="space-y-3 text-sm" data-id="element-5986">
                  <div data-id="element-5987">
                    <p className="font-bold mb-1" data-id="element-5988">Passenger Items</p>
                    <ul className="space-y-1" data-id="element-5989">
                      <li data-id="element-5990">passenger entry/lifts</li>
                      <li data-id="element-5991">emergency exits</li>
                      <li data-id="element-5992">seating</li>
                    </ul>
                  </div>

                  <div data-id="element-5993">
                    <p className="font-bold mb-1" data-id="element-5994">Entry/Exit</p>
                    <ul className="space-y-1" data-id="element-5995">
                      <li data-id="element-5996">doors/mirrors</li>
                    </ul>
                  </div>

                  <div data-id="element-5997">
                    <p className="font-bold mb-1" data-id="element-5998">Front Suspension</p>
                    <ul className="space-y-1" data-id="element-5999">
                      <li data-id="element-6000">level/air leaks</li>
                    </ul>
                  </div>

                  <div data-id="element-6001">
                    <p className="font-bold mb-1" data-id="element-6002">Front Wheel</p>
                    <ul className="space-y-1" data-id="element-6003">
                      <li data-id="element-6004">rim</li>
                      <li data-id="element-6005">tires</li>
                      <li data-id="element-6006">hub oil seal</li>
                      <li data-id="element-6007">lug nuts</li>
                    </ul>
                  </div>

                  <div data-id="element-6008">
                    <p className="font-bold mb-1" data-id="element-6009">Side of Vehicle</p>
                    <ul className="space-y-1" data-id="element-6010">
                      <li data-id="element-6011">fuel tank</li>
                      <li data-id="element-6012">compartments</li>
                      <li data-id="element-6013">battery/box</li>
                    </ul>
                  </div>

                  <div data-id="element-6014">
                    <p className="font-bold mb-1" data-id="element-6015">Rear Wheels</p>
                    <ul className="space-y-1" data-id="element-6016">
                      <li data-id="element-6017">rims</li>
                      <li data-id="element-6018">tires</li>
                      <li data-id="element-6019">axle seals</li>
                      <li data-id="element-6020">lug nuts</li>
                      <li data-id="element-6021">spacers</li>
                    </ul>
                  </div>

                  <div data-id="element-6022">
                    <p className="font-bold mb-1" data-id="element-6023">*Rear Suspension</p>
                    <ul className="space-y-1" data-id="element-6024">
                      <li data-id="element-6025">level/air leak</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center mt-8" data-id="element-6026">
            <h2 className="text-3xl font-bold mb-4" data-id="element-6027">
              Need Professional Vehicle Inspection?
            </h2>
            <p className="text-xl mb-6" data-id="element-6028">
              Certified DOT inspections and comprehensive vehicle safety checks
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-6029">
              <Phone className="mr-3" size={24} data-id="element-6030" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-6031">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}